<template>
  <section class="container" style="min-height:50vh">
    <section id="firebaseui-auth-container"></section>
  </section>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import * as firebaseui from 'firebaseui'
import 'firebaseui/dist/firebaseui.css'

export default {
  name: 'Login',
  data() {
    return {
      ui: null
    }
  },
  async mounted() {
    const user = firebase.auth().currentUser
    if (user) {
      this.$router.replace({ path: '/dashboard' })
      return
    }

    this.ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth())

    const uiConfig = {
      signInFlow: 'popup',
      signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID
      ],
      credentialHelper: firebaseui.auth.CredentialHelper.NONE,
      callbacks: {
        signInSuccessWithAuthResult: (authResult, redirectUrl) => {
          this.$router.replace({ path: '/dashboard' })
          return false
        },
        uiShown: () => {
        }
      }
    }

    this.ui.start('#firebaseui-auth-container', uiConfig)
  },
  beforeDestroy() {
    if (this.ui) {
      this.ui.reset()
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Login.vue